import React, { useState } from "react";

const useSidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return { sidebarOpen, setSidebarOpen, toggleSidebar };
};

export default useSidebar;
